import { FileWithPreview } from 'react-dropzone';

import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const UPLOAD_INTERNAL_BANNER_IMAGE = 'UPLOAD_INTERNAL_BANNER_IMAGE';
export type UPLOAD_INTERNAL_BANNER_IMAGE = typeof UPLOAD_INTERNAL_BANNER_IMAGE;
export interface UploadInternalBannerImage {
    type: UPLOAD_INTERNAL_BANNER_IMAGE;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    filesToUpload: FileWithPreview[];
    isLocalUploading?: boolean;
}

export function uploadInternalBannerImageAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    filesToUpload: FileWithPreview[],
    isLocalUploading?: boolean
): UploadInternalBannerImage {
    return {
        type: UPLOAD_INTERNAL_BANNER_IMAGE,
        bannerId,
        resourceId,
        filesToUpload,
        isLocalUploading
    };
}
